export default __webpack_public_path__ + "static/favicon-686f4a7767bdc028abf493a0fcee18e3.ico";